module.exports = __webpack_public_path__ + "static/media/expertise.e4f84b24.svg";